import React from "react";
import "../styles/SalesItemCard.css";
import handleImageErrorWithPasomaruFallback from '../utils/imageUtils';
import { useNavigate, useLocation } from "react-router-dom";
import { useReturnParams } from '../hooks/useReturnParams';

const SalesItemCard = ({ item, onChange, storeId , categoryId, currentPage, filterMode, sortPeriod, sortOrder, titleKeyword, customStart, customEnd, onBeforeDetail }) => {
  const handleInput = (field, value) => {
    onChange(item.inventory_id, field, value);
  };
  const navigate = useNavigate();
  const location = useLocation();
  const { saveReturnParams } = useReturnParams();
  
  const handleNavigateToDetail = (itemId) => {
    const query = new URLSearchParams({
      category_id: categoryId ?? "",
      page: currentPage ?? "1",
      filter_mode: filterMode ?? "",
      sortPeriod: sortPeriod ?? "",
      sortOrder: sortOrder ?? "",
      title: titleKeyword ?? "",
    });

    if (sortPeriod === "custom" && customStart && customEnd) {
      query.set("custom_start", customStart);
      query.set("custom_end", customEnd);
    }

    const returnUrl = `${location.pathname}?${query.toString()}`;
    saveReturnParams(returnUrl);
    onBeforeDetail?.();
    navigate(`/Inventory_detail/${itemId}/${storeId}?${query.toString()}`);
  };

  const handleNumericInput = (field) => ({
    value: item[field] ?? "",
    onChange: (e) => handleInput(field, e.target.value),
    onBlur: (e) => {
      const val = e.target.value;
      const num = Number(val);
      if (!isNaN(num)) {
        handleInput(field, num);
      }
    },
    onFocus: (e) => e.target.select(),
  });

  const copyToClipboard = async (text) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
      }

      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";

      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      document.execCommand("copy");

      document.body.removeChild(textarea);
    } catch (err) {
      console.error("コピー失敗:", err);
    }
  };

  return (
    <div className="SalesItemCard-container">
      {/* 左：商品画像 */}
      <div className="SalesItemCard-image">
        <img
          src={`/media/product_images/${item.sku}.jpg`}
          alt="商品画像"
          onError={(e) => handleImageErrorWithPasomaruFallback(e, item.sku)}
        />
      </div>

      {/* 右：情報列 */}
      <div className="SalesItemCard-details">
        <div className="SalesItemCard-title">
          <button
            type="button"
            className="SalesItemCard-detail-button"
            onClick={() => handleNavigateToDetail(item.inventory_id)}
          >
            詳細
          </button>

          <div className="SalesItemCard-item-name">
            {item.item_name}
          </div>

          {item.jan && (
            <div
              className="SalesItemCard-jan"
              onClick={() => copyToClipboard(String(item.jan))}
              title="クリックでJANをコピー"
            >
              {item.jan}
            </div>
          )}
          
        </div>
        <div className="SalesItemCard-info-row">
          <div className="SalesItemCard-info-50">在庫</div>
          <div className="SalesItemCard-info-90">買取価格</div>
          <div className="SalesItemCard-info-90">特別買取</div>
          <div className="SalesItemCard-info-90">最終売買</div>
          <div className="SalesItemCard-info-90">販売価格</div>
          <div className="SalesItemCard-info-90">SET価格</div>
          <div>集計数:</div>
          <div className="SalesItemCard-info-40">C</div>
          <div className="SalesItemCard-info-40">W</div>
          <div className="SalesItemCard-info-40">1M</div>
          <div className="SalesItemCard-info-40">3M</div>
          <div className="SalesItemCard-info-40">6M</div>
          <div className="SalesItemCard-info-40">12M</div>
        </div>
        <div className="SalesItemCard-databox">
          <div className="SalesItemCard-default">{item.stock}</div>

          <div className="SalesItemCard-inputbox">
            <div className="SalesItemCard-switches">
              <label>
                <input
                  type="checkbox"
                  name={`SalesItemCard-top-${item.inventory_id}`}
                  checked={item.buy_top_switch}
                  onChange={(e) =>
                    handleInput("buy_top_switch", e.target.checked)
                  }
                />{" "}
                TOP
              </label>
            </div>
            <input
              type="text"
              name={`SalesItemCard-buy_price-${item.inventory_id}`}
              {...handleNumericInput("buy_price")}
            />
          </div>

          <div className="SalesItemCard-inputbox">
            <div className="SalesItemCard-switches">
              <label>
                <input
                  type="checkbox"
                  name={`SalesItemCard-shoponly-${item.inventory_id}`}
                  checked={item.buy_specialprice_switch}
                  onChange={(e) =>
                    handleInput("buy_specialprice_switch", e.target.checked)
                  }
                />{" "}
                特別
              </label>
              <label>
                <input
                  type="checkbox"
                  name={`SalesItemCard-shoponly-${item.inventory_id}`}
                  checked={item.buy_specialprice_shoponly}
                  onChange={(e) =>
                    handleInput("buy_specialprice_shoponly", e.target.checked)
                  }
                />{" "}
                店
              </label>
            </div>
            <input
              type="text"
              name={`SalesItemCard-buy_specialprice-${item.inventory_id}`}
              {...handleNumericInput("buy_specialprice")}
            />
          </div>

          <div className="SalesItemCard-2line90">
            <div className="lastbuysell">
              {item.last_sale_date ? item.last_sale_date.slice(0, 10) : "なし"}
            </div>
            <div className="lastbuysell">
              {item.last_purchase_date
                ? item.last_purchase_date.slice(0, 10)
                : "なし"}
            </div>
          </div>

          <div className="SalesItemCard-sellprice">
            <input
              type="text"
              name={`SalesItemCard-sell_price-${item.inventory_id}`}
              {...handleNumericInput("sell_price")}
            />
          </div>

          <div className="SalesItemCard-sellprice">
            <input
              type="text"
              name={`SalesItemCard-sell_set_price-${item.inventory_id}`}
              {...handleNumericInput("sell_set_price")}
            />
          </div>

          <div className="SalesItemCard-2line">
            <div className="SalesItemCard-row">
              <span>販売数:</span>
              {["custom", "1week", "1month", "3month", "6month", "12month"].map(
                (key) => (
                  <div key={key} className="SalesItemCard-box">
                    {item.sales_summary?.[key] ?? 0}
                  </div>
                )
              )}
              {typeof item.avg_sales_1m === "number" && (
                <div style={{ fontSize: "12px", color: "#ccc" }}>
                  🧮 平均販売数（月）: {item.avg_sales_1m.toFixed(1)} 個
                </div>
              )}
            </div>
            <div className="SalesItemCard-row">
              <span>仕入数:</span>

              {["custom", "1week", "1month", "3month", "6month", "12month"].map(
                (key) => {
                  const qty = item.purchase_summary?.[key] ?? 0;
                  const avgPrice = item.purchase_average_summary?.[key] ?? 0;

                  return (
                    <div
                      key={key}
                      className="SalesItemCard-box SalesItemCard-purchase-box"
                    >
                      <div className="SalesItemCard-purchase-qty">
                        {qty}
                      </div>

                      <div className="SalesItemCard-purchase-avg">
                        {qty > 0
                          ? `¥${avgPrice.toLocaleString()}`
                          : "-"}
                      </div>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesItemCard;
